// Original source:
// https://stackoverflow.com/questions/7616461/generate-a-hash-from-string-in-javascript
function hashCode( str ) {
  let hash = 0
  if ( str == null || str.length === 0 ) {
    return hash
  }
  for ( let i = 0; i < str.length; i++ ) {
    const chr = str.charCodeAt( i )
    hash = ( ( hash << 5 ) - hash ) + chr;
    hash |= 0 // Convert to 32bit integer
  }
  return Math.abs( hash ) // make it positive
}

function shardId( number, key ) {
  return hashCode( key ) % number
}

function getUrl( shardId, templateUrl, defaultUrl ) {
  if ( shardId === -1 || templateUrl == null ) {
    return defaultUrl
  }
  // eslint-disable-next-line no-template-curly-in-string
  return templateUrl.replace( '${shard}', `${shardId}` )
}

export default {
  hashCode,
  shardId,
  getUrl
}
